import React, { FC, Suspense } from 'react';
import { LinearProgress } from '@mui/material';

const Module = React.lazy(() => import('modules/NotFoundModule'));
const NotFoundElement: FC = () => (
  <Suspense fallback={<LinearProgress />}>
    <Module />
  </Suspense>
);

export default NotFoundElement;
